
<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Sign Up</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form @submit.prevent="userSignUp">
          <v-layout column>
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">{{ error }}</v-alert>
            </v-flex>
            <v-flex>
              <v-text-field
                name="firstName"
                label="First Name"
                id="firstName"
                v-model="firstName"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="lastName"
                label="Last Name"
                id="lastName"
                v-model="lastName"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                type="password"
                v-model="password"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="confirmPassword"
                label="Confirm Password"
                id="confirmPassword"
                type="password"
                v-model="passwordConfirm"
                :rules="[comparePasswords]"
                required
                ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn color="primary" type="submit" :disabled="loading">Sign Up</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'Signup',
    data() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        passwordConfirm: '',
        alert: false
      }
    },
    methods: {
      userSignUp() {
        if (this.comparePasswords !== true){
          return
        }
        try {
          this.$store.dispatch('userSignUp', {email: this.email, password: this.password, firstName: this.firstName, lastName: this.lastName});
        }
        catch(err)
        {
          this.error = err;
          this.alert = true;
        }
      }
    },
    computed: {
      comparePasswords() {
        return this.password === this.passwordConfirm ? true : 'Passwords don\'t match'
      },
      error() {
        return this.$store.state.error;
      },
      loading() {
        return this.$store.state.loading;
      }
    },
    watch: {
      error(value) {
        if (value) {
          this.alert = true;
        }
      },
      alert(value) {
        if (!value) {
          this.$store.commit('setError', null);
        }
      }
    }
  }
</script>

<style scoped>
</style>